export default __webpack_public_path__ + "static/media/pop6.ae08b13f.webp";